import { createIcon } from "@chakra-ui/react";

export const ErrorAlt = createIcon({
  displayName: "ErrorAlt",
  viewBox: "0 0 24 24",
  d: "M12 2.25a9.75 9.75 0 1 1 0 19.5 9.75 9.75 0 0 1 0-19.5zM12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24zm0-18c-.623 0-1.125.502-1.125 1.125v5.25c0 .623.502 1.125 1.125 1.125s1.125-.502 1.125-1.125v-5.25C13.125 6.502 12.623 6 12 6zm1.5 10.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z",
  defaultProps: {
    "aria-label": "An exclamation mark within a hollow circle"
  }
});

export default ErrorAlt;
